// src/components/Matchup.tsx
import React from "react";

interface MatchupProps {
  team1: string;
  team2: string;
  score1: number;
  score2: number;
  team1Logo: string; // Bild-URL für Team 1
  team2Logo: string; // Bild-URL für Team 2
  date: string;
  className?: string; // Allow for optional className prop
}

const Matchup: React.FC<MatchupProps> = ({
  team1,
  team2,
  score1,
  score2,
  team1Logo,
  team2Logo,
  date,
  className,
}) => {
  return (
    <div className="my-4">
      <div className="text-sm font-thin text-gray-400">
        {new Date(date).toLocaleDateString("de-DE", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
        })}
      </div>
      <div
        className={`bg-highlight p-2 rounded  shadow-md flex items-center justify-between ${className}`}
      >
        <div className="flex items-center justify-center ">
          <img
            src={team1Logo}
            alt={`${team1} logo`}
            className="w-10 h-10 object-contain mx-2"
          />
          <div className="text-gray-300 w-full text-nowrap">
            {score1}
            {" : "}
            {score2}
          </div>
          <img
            src={team2Logo}
            alt={`${team2} logo`}
            className="w-10 h-10 object-contain mx-2 "
          />
        </div>
      </div>
    </div>
  );
};

export default Matchup;
